module.exports = __webpack_public_path__ + "img/CDN.bc013c5b.svg";